import React from 'react';

export default function GlassProgress({ label, value, max = 100 }) {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className="glass-progress">
      <div className="glass-progress__row"><span>{label}</span><span>{value}</span></div>
      <div className="glass-progress__track"><div className="glass-progress__bar" style={{ width: `${pct}%` }} /></div>
    </div>
  );
}